import { ShieldCheck, Headset, Crown, Coins } from "@phosphor-icons/react";

const ITEMS = [
  {
    I: Crown,
    t: "Curated Cabin Inventory",
    short: "Better business & first-class seats from direct carrier negotiation.",
    d: "We negotiate directly with US and international carriers for genuinely better seats in business and first class.",
  },
  {
    I: Headset,
    t: "Customer-First Care",
    short: "Real people, no scripts. Your trip at the centre of every decision.",
    d: "Real people answering real questions. Our support team is trained to put your trip — not a script — at the centre of every decision.",
  },
  {
    I: ShieldCheck,
    t: "Price-Beat Guarantee",
    short: "Find it cheaper in 24h and we refund the difference. No paperwork.",
    d: "Find the same itinerary cheaper within 24 hours and we'll refund the difference. No paperwork.",
  },
  {
    I: Coins,
    t: "Transparent Pricing",
    short: "All taxes & fees shown upfront. No drip pricing, no gate surprises.",
    d: "All taxes, surcharges, and fees shown upfront. No drip pricing, no surprise add-ons at the gate.",
  },
];

export default function WhyUs() {
  return (
    <section
      className="bg-[#F7F5F0] py-10 md:py-16 px-5 md:px-12 lg:px-24"
      data-testid="whyus-section"
    >
      <div className="max-w-3xl mb-5 md:mb-8">
        <p className="tcp-overline text-[#C29B62] mb-2 md:mb-3">Why TheCityPair</p>
        <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl tracking-tighter leading-tight md:leading-none text-[#1C1C1C]">
          A standard the rest of the industry <em className="italic">quietly</em> envies.
        </h2>
      </div>

      {/* Mobile: 2 × 2 grid, compact short copy.
          Desktop / tablet: keep the original 4 / 2-column layout with longer copy. */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#E0DDD6]">
        {ITEMS.map(({ I, t, short, d }, i) => (
          <div
            key={i}
            className="bg-[#F7F5F0] p-4 md:p-6 lift"
            data-testid={`why-${i}`}
          >
            <I size={28} weight="duotone" className="text-[#C29B62] mb-3 md:mb-4 md:w-9 md:h-9" />
            <h3 className="font-serif text-base md:text-2xl tracking-tight text-[#1C1C1C] mb-2 md:mb-2.5 leading-tight">
              {t}
            </h3>
            {/* Show the short pitch on mobile to fit the smaller card; show the
                full description on tablet/desktop. */}
            <p className="text-[#666460] leading-relaxed text-xs md:text-sm md:hidden">
              {short}
            </p>
            <p className="text-[#666460] leading-relaxed text-sm hidden md:block">
              {d}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
